module.exports = __webpack_public_path__ + "img/copy_b.de7458db.svg";